export class Perks {
    id: number
    title: string
    icon_url: string
    description: string
    created_at: string
    updated_at: string
}